import Dashboard from "components/Template/Dashboard";
import React, { useEffect, useState } from "react";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import { useHistory } from "react-router-dom";
import Loading from "components/Loading";
import { groupChannelHistory } from "services/manageFamilies";
import Message from "components/Message";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";
import ModalExporting from "./ModalExporting";
import ButtonExport from "./ButtonExport";
import ModalReceiveEmail from "./ModalReceive";
import { handleObjectMessages } from "helpers/handleObjectMessages";

type Props = {};

const GroupManagementChannel: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();
  const [groupId, setGroupId] = useState("");
  const [groupName, setGroupName] = useState("");
  const [channelId, setChannelId] = useState("");
  const [channelName, setChannelName] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showEmail, setShowEmail] = useState(false);

  const getConversations = async () => {
    try {
      setLoading(true);
      const { data } = await groupChannelHistory(groupId, channelId);
      const messagesFormatted = handleObjectMessages(data)
      setMessages(messagesFormatted);
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setGroupId(history.location.pathname.split("/")[2]);
    setChannelId(history.location.pathname.split("/")[4]);
    setGroupName(history.location.state.name);
    setChannelName(history.location.state.channel);
    if (groupId && channelId) {
      getConversations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelId, groupId, history]);

  return (
    <Dashboard
      icon={ArrowLeft}
      title={`Channel ${channelName} | Conversation History`}
      breadcrumb={[
        { name: "Manage Families", active: false, path: "/manage-families" },
        { name: groupName, active: false, path: `/manage-families/${groupId}/details` },
        { name: `Channel ${channelName}`, active: false, path: `/manage-families/${groupId}/details` },
        { name: "Conversation History", active: true },
      ]}
      children={
        <>
          <Loading loading={loading} />
          <ModalExporting
            show={show}
            setShow={setShow}
            setChannelId={setChannelId}
            channelId={channelId}
            setLoading={setLoading}
            setShowEmail={setShowEmail}
          />
          <ModalReceiveEmail show={showEmail} setShow={setShowEmail} />
          <ButtonExport setShow={setShow} />
          <div className="w-full h-96 min-h-desktop-message bg-bt-white overflow-auto">
            {messages.length > 0 &&
              messages.map((message: any, i: number) => (
                <div key={message.id}>
                  <Message messages={messages} message={message} index={i} />
                </div>
              ))}
            <ToastContainer />
          </div>
        </>
      }
    />
  );
};

export default GroupManagementChannel;
